import { Box, Button, Checkbox, FormControlLabel, Grid, IconButton, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../../Styles/Colors'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { IP_DOC_NOTES_LAYOUT } from '../../../../Utility/Constants'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { AddCircle } from '@material-ui/icons'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'

const DocIpLayoutConfig = () => {
    const [layout, setLayout] = useState([]);
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [systemName, SetSystemName] = useState('')
    const [customName, setCustomName] = useState('')
    const [active, setActive] = useState(false)
    const [maxCount, setMaxCount] = useState(10)
    const [newLayCount, setNewLayCount] = useState(0)
    const [dupLayout, setDupLayout] = useState('[]')
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    // API STARTS =====>

    useEffect(() => {
        getIPDocLayoutConfig()
    }, [])

    const getIPDocLayoutConfig = () => {
        try {
            RestAPIService.getAll(Serviceurls.SAR_IP_DOC_NOTES_NEW_LAYOUT_CONFIG)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let data = response?.data?.data?.template_data?.length > 0 ? response?.data?.data?.template_data : IP_DOC_NOTES_LAYOUT
                        let maxCt = response?.data?.data?.max_layout_count ? response?.data?.data?.max_layout_count : 10
                        let newLay = response?.data?.data?.new_layout_count ? response?.data?.data?.new_layout_count : 0
                        setLayout(data)
                        setMaxCount(maxCt)
                        setNewLayCount(newLay)
                        setDupLayout(JSON.stringify(data))
                    }
                }).catch(error => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error?.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const postIPDocLayoutConfig = () => {
        try {
            let cutomEmpty = layout?.filter(item => item.custom_name === '')
            if (maxCount === newLayCount) {
                errorMessage(`Maximum count exceeded for new layout`)
            }else if(cutomEmpty?.length){
                errorMessage('Custom name should not be empty')
            } else {
                let data = { template_data: layout }
                RestAPIService.create(data, Serviceurls.SAR_IP_DOC_NOTES_NEW_LAYOUT_CONFIG)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            successMessage(response?.data?.message)
                            getIPDocLayoutConfig()
                        }
                    }).catch(error => {
                        if (error?.response?.data?.message) {
                            errorMessage(error?.response?.data?.message)
                        } else {
                            errorMessage(error?.message)
                        }
                    })
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    // API ENDS ======>

    const handleDragStart = (index) => {
        setDraggedIndex(index);
    };

    const handleDragOver = (event) => {
        event.preventDefault(); // Required to allow drop
    };

    const handleDrop = (dropIndex) => {
        try {
            if (draggedIndex === null || draggedIndex === dropIndex) return;

            const updated = [...layout];
            const [draggedItem] = updated.splice(draggedIndex, 1);
            updated.splice(dropIndex, 0, draggedItem);

            setLayout(updated);
            setDraggedIndex(null);
        } catch (error) {
            errorMessage(error.message)
        }
    };

    return (
        <Box component={'div'} sx={{ backgroundColor: Colors.Background, height: '79dvh' }}>
            <Box component={'div'} p={'0.5rem'}>
                <Box component={'div'} height={'70dvh'} sx={{ backgroundColor: Colors.white }} overflow={'auto'}>
                    <Box component={'div'} width={'50%'}>
                        <Box component={'div'} p={'0.5rem'} display={'flex'}>
                            <Typography flex={0.5} fontSize={'1rem'} fontWeight={600}>System Name</Typography>
                            <Typography flex={0.5} fontSize={'1rem'} fontWeight={600}>Custom Name</Typography>
                        </Box>
                        {layout?.map((item, index) => {
                            return (
                                <Box component={'div'} p={'0.5rem'} display={'flex'}
                                    key={index}
                                    draggable
                                    onDragStart={() => handleDragStart(index)}
                                    onDragOver={handleDragOver}
                                    onDrop={() => handleDrop(index)}
                                >
                                    <Box flex={0.5}>
                                        <Box display={'flex'} alignItems={'center'}>
                                            <Box component={'img'} src={ImagePaths.DragIndicator.default} alt="" sx={{ cursor: 'pointer' }} />
                                            <FormControlLabel sx={{ ml: '0.5rem' }} control={<Checkbox checked={item.is_active} size='small' />}
                                                onChange={(e) => {
                                                    let update = [...layout]
                                                    update[index]['is_active'] = e.target.checked
                                                    setLayout(update)
                                                }}
                                                label={item?.system_name} />
                                        </Box>
                                    </Box>
                                    <Box flex={0.5}>
                                        <TextField
                                            size='small'
                                            sx={{ height: '5dvh', width: '15dvw' }}
                                            value={item?.custom_name}
                                            onChange={(e) => {
                                                let value = e.target.value
                                                let update = [...layout]
                                                update[index]['custom_name'] = value
                                                setLayout(update)
                                            }}
                                        />
                                    </Box>
                                </Box>
                            )
                        })}
                        <Box component={'div'}>
                            <Box component={'div'} p={'0.5rem'} display={'flex'}>
                                <Box flex={0.5}>
                                    <Box display={'flex'} alignItems={'center'}>
                                        <Box component={'img'} src={""} alt="" sx={{ cursor: 'pointer' }} />
                                        <FormControlLabel sx={{ ml: '0.5rem' }} control={<Checkbox checked={active} size='small' />}
                                            onChange={(e) => { setActive(e.target.checked) }}
                                            label={
                                                <TextField
                                                    size='small'
                                                    sx={{ height: '5dvh', width: '15dvw' }}
                                                    value={systemName}
                                                    onChange={(e) => { SetSystemName(e.target.value) }}
                                                />
                                            }
                                        />
                                    </Box>
                                </Box>
                                <Box flex={0.5}>
                                    <TextField
                                        size='small'
                                        sx={{ height: '5dvh', width: '13dvw' }}
                                        value={customName}
                                        onChange={(e) => { setCustomName(e.target.value) }}
                                    />
                                    <IconButton disabled={customName === ''}
                                        onClick={() => {
                                            let newLay = layout?.filter(item => item?.is_new)
                                            if (maxCount === newLay?.length) {
                                                errorMessage(`You have reached the maximum limit of ${maxCount} custom layouts`)
                                            } else {
                                                if(layout.some(item => ((item.custom_name === customName) || (item.system_name === systemName) || (item.system_name === customName) || (item.custom_name === systemName)))){
                                                    errorMessage('System name or Custom Name Already Exists')
                                                }else{
                                                    let new_data = { field_name: systemName, system_name: systemName, custom_name: customName || systemName, is_active: active, is_new: true }
                                                    let update = [...layout, new_data]
                                                    setLayout(update)
                                                    setActive(false)
                                                    SetSystemName('')
                                                    setCustomName('')
                                                }
                                            }
                                        }}
                                    ><AddCircle color={customName !== '' ? 'primary' : 'disabled'} /></IconButton>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box component={'div'} height={'8dvh'} display={'flex'} justifyContent={'center'} alignItems={'center'} border={'1px solid lightgray'} >
                    <Button variant='outlined' sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '1rem' }}
                        onClick={() => {
                            let dupData = IP_DOC_NOTES_LAYOUT
                            setLayout(dupData)
                        }}
                    >Reset Layout</Button>
                    <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '1rem' }}
                        onClick={() => postIPDocLayoutConfig()}
                    >Save</Button>
                </Box>
            </Box>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Box>
    )
}

export default DocIpLayoutConfig